import * as React from 'react';

import C3ReservationsLogoImg from '../assets/c3reservation-logo.png';
import { cn } from '../utils/shadcn';

function C3ReservationsLogo(
  props: React.ImgHTMLAttributes<HTMLImageElement>
): React.JSX.Element {
  const { className: classNameProp, ...otherProps } = props;

  return (
    <img
      src={C3ReservationsLogoImg}
      alt='C3 Reservations logo'
      className={cn('filter brightness-90 scale-175', classNameProp)}
      {...otherProps}
    />
  );
}

export default C3ReservationsLogo;
